import React from "react";
import { Box } from "@mui/material";
import { InputLabel } from "../../components";
import { StyledStack } from "./styles";

const required = true;

export const items = [
  {
    id: "material",
    label: "Material",
  },
  {
    id: "quantity",
    label: "Quantity",
  },
  {
    id: "x",
    label: "",
  },
];

export const LaborMaterialsTableHeader = () => {
  return (
    <StyledStack sx={{ backgroundColor: "hubColors.greyLighter" }}>
      {items?.map((cell, idx) => (
        <Box
          key={idx}
          sx={{
            borderRight: "1px solid",
            borderColor: "hubColors.greyLight",
            padding: "4px 5px",
            height: "100%",
          }}
        >
          <InputLabel
            key={cell.id}
            label={cell.label}
            required={cell.required}
            marginLeft="5px"
            marginBottom="0px"
            sx={{
              textWrap: "nowrap",
            }}
          />
        </Box>
      ))}
    </StyledStack>
  );
};

export default LaborMaterialsTableHeader;
